module.exports = __webpack_public_path__ + "static/img/3.36e203b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/6/1/sp/3.png
// module id = /q9u
// module chunks = 0